<template>
  <v-navigation-drawer
    app
    location="left"
    v-model="editdrawer"
    :width="!hovering ? '316' : '48'"
    height="100%"
    class="k-app-sidebar"
  >
    <transition name="fade" mode="out-in">
      <div v-if="!hovering" class="k-app-sidebar-shell">
        <div class="k-app-sidebar-head d-flex">
          <k-app-logo
            class="align-start"
            style="cursor: pointer"
            @click="$router.push('/')"
            height="40"
            max-width="170"
          ></k-app-logo>
          <div
            class="sidebar-btn is-expanded ml-auto my-auto"
            @click="hovering = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <rect width="32" height="32" rx="5" fill="#F5F5F5" />
              <mask
                id="mask0_11179_10109"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="4"
                y="4"
                width="24"
                height="24"
              >
                <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_11179_10109)">
                <path
                  d="M18.4004 22L12.4004 16L18.4004 10L19.6754 11.275L14.9504 16L19.6754 20.725L18.4004 22Z"
                  fill="#696969"
                />
              </g>
            </svg>
          </div>
        </div>
        <k-spacing y="6"></k-spacing>
        <div class="k-app-sidebar-body">
          <v-list nav color="var(--primary)">
            <v-list-item
              link
              v-for="item in sidebar_items"
              :key="item.title"
              :to="item.to"
              :active="isActive(item.to)"
              rounded="xl"
              base-color="var(--neutral-700)"
            >
              <template v-slot:prepend>
                <v-icon :icon="item.icon"></v-icon>
              </template>
              <v-list-item-title v-text="item.title"></v-list-item-title>
              <template v-slot:append>
                <div v-if="item.count > 0" class="badge">{{ item.count }}</div>
              </template>
            </v-list-item>
          </v-list>
        </div>
        <div class="k-app-sidebar-footer" v-if="mainStore.user.id != -1">
          <v-list lines="two" class="bg-white">
            <v-list-item
            class="bg-white"
              :title="mainStore.user.firstname + ' ' + mainStore.user.lastname"
              :subtitle="mainStore.user.email"
              @click="$router.push('/accountgegevens')"
            >
              <template v-slot:prepend>
                <v-avatar
                  style="cursor: pointer"
                  @click="$router.push('/accountgegevens')"
                  color="var(--primary-300)"
                  size="48"
                  :image="`${configdata.url.cdn}/users/avatars/${mainStore.user.profilepicture}`"
                ></v-avatar>
              </template>

              <template v-slot:append>
                <v-btn
                  @click.prevent="signout()"
                  color="#696969"
                  icon="mdi-logout"
                  variant="text"
                ></v-btn>
              </template>
            </v-list-item>
          </v-list>
        </div>
      </div>
      <div v-else class="pa-2 pt-4">
        <div class="d-flex justify-center">
          <div class="sidebar-btn is-collapsed" @click="hovering = false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <rect width="32" height="32" rx="5" fill="#F5F5F5" />
              <mask
                id="mask0_11179_8799"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="4"
                y="3"
                width="24"
                height="25"
              >
                <rect x="4" y="3.99939" width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_11179_8799)">
                <path
                  d="M17.0502 15.9994L12.3252 11.2744L13.6002 9.99939L19.6002 15.9994L13.6002 21.9994L12.3252 20.7244L17.0502 15.9994Z"
                  fill="#696969"
                />
              </g>
            </svg>
          </div>
        </div>
      </div>
    </transition>
  </v-navigation-drawer>
</template>

<script>
import { useMainStore } from "@/stores/store";
import config from "@/config";
const cookies = require("js-cookie");
import api from "../../../services/api";
import { routeAvailable } from "@/util/integrations";

export default {
  setup() {},
  data: () => ({
    mainStore: useMainStore(),
    editdrawer: true,
    rail: true,
    hovering: false,
    admin_items: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard-outline",
        to: "/",
      },
      {
        title: "Activiteiten",
        icon: "mdi-meditation",
        to: "/activiteiten",
      },
      {
        title: "Bedrijfspagina's",
        icon: "mdi-briefcase-outline",
        to: "/bedrijfspaginas",
      },
      {
        title: "Accountgegevens",
        icon: "mdi-account-circle-outline",
        to: "/accountgegevens",
      },
      {
        title: "Intakeformulieren",
        icon: "mdi-file-document-edit-outline",
        to: "/intake-formulieren",
      },
      {
        title: "Reviews",
        icon: "mdi-star-outline",
        to: "/reviews",
      },
      {
        title: "Specialisten",
        icon: "mdi-account-box-outline",
        to: "/specialisten",
      },
      {
        title: "Form builder",
        icon: "mdi-clipboard-text",
        to: "/form-builder",
      },
      {
        title: "Instellingen",
        icon: "mdi-cog-outline",
        to: "/instellingen",
      },
     
      {
        title: "Checkbestand",
        icon: "mdi-check-circle-outline",
        to: "/checkbestand",
      },
      {
        title: "Activiteiten herplannen",
        icon: "mdi-calendar-sync-outline",
        to: "/activiteiten-herplannen",
        count: 0,
      },
    ],

    mini: true,
  }),
  watch: {},
  props: {
    drawer: Boolean,
  },
  computed: {
    configdata() {
      return config;
    },
    sidebar_items() {
      if (this.mainStore.user.id == -1) {
        return [];
      } else {
        return this.admin_items.filter((item) => routeAvailable(this.$router.resolve(item.to)));
      }
    },
  },
  mounted() {
    if (routeAvailable(this.$router.resolve("/activiteiten-herplannen"))) this.getReplanCount();
  },
  methods: {
    isActive(path) {
      if (path === "/") {
        return this.$route.path === "/";
      }
      return this.$route.path.startsWith(path);
    },
    redirect(item, type) {
      if (type == "link") {
        window.open(item, "_blank");
      } else {
        this.$router.push(item);
      }
    },
    getReplanCount() {
      api
        .get(`v1/activities/0/replan_count`)
        .then((res) => {
          const count = res.data.count;
          const itemIndex = this.admin_items.findIndex(
            (item) => item.to === "/activiteiten-herplannen",
          );
          if (itemIndex !== -1) {
            this.admin_items[itemIndex].count = count;
          }
        })
        .catch((err) => {
          console.error("Failed to fetch replan count:", err);
        });
    },
    signout() {
      api
        .put(`v1/auth/logout`, {
          refresh_token: cookies.get("fmw_refresh_token"),
        })
        .then((res) => {
          if (res.data.success) {
            cookies.remove("fmw_access_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("fmw_refresh_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("user", {
              domain: config.cookiedomain,
              path: "/",
            });
            location.replace(config.url.login);
          }
        })
        .catch((err) => {
          switch (err.response.status) {
            default:
              this.$toast.error("Oops, something went wrong");
              break;
          }
        });
    },
  },
};
</script>
